/* eslint-disable @typescript-eslint/no-implied-eval */
const uuid = require('uuid');
const RuleEngine = require('node-rules');
const parser = require('./custom-sqlite-parser');
const { encodeSpecialChars } = require('../stringUtil');
const { TVL } = require('./three-value-logic');

/**
 * Initialize a new rules engine object.
 * @returns a new instance of a RuleEngine
 */
function initRulesEngine() {
  return new RuleEngine();
}
exports.initRulesEngine = initRulesEngine;

/**
 * Adds the given rule condition + consequence to a rule engine
 * @param engine
 * @param {string} ruleCondition
 * @param ruleId
 * @param procedureId
 * @param ruleType
 * @param tags
 * @param rulePriority
 * @param {function} callback
 */
function addRule(
  engine,
  ruleCondition,
  ruleId,
  procedureId,
  ruleType,
  tags = [],
  rulePriority = 1,
  callback = () => {},
) {
  const rule = {
    priority: rulePriority,
    name: ruleId || uuid.v4(),
    ruleType,
    on: false,
    procedureId,
    condition(options) {
      const jsExpression = parser.convertSqliteForNodeRules(ruleCondition);
      // Construct the function to run the rule, then run that function with the current fact (this),
      // the parser functions, and the TVL object in scope.
      const result = Function('fact', 'functions', 'TVL', `return ${jsExpression}`)(this, parser.functions, TVL);
      const ruleTriggered = result === true;
      // Only trigger rule if result is strictly true (not null/unknown or false)
      options.when(ruleTriggered);
    },
    consequence(R) { // Changed from (R) => { ... }
      callback();
      R.next();
    },
  };
  tags.forEach((tag) => {
    rule[tag] = 'yes';
  });
  engine.register(rule);
  return rule;
}
exports.addRule = addRule;

/**
 * Evaluate a json fact against this rule engine,
 * passing the result to the onskip or ontrigger handlers
 * @param {RuleEngine} ruleEngine
 * @param {json} fact
 * @param {function} onSkip
 * @param {function} onTrigger
 */
function evaluateFact({
  ruleEngine,
  fact,
  onSkip = () => {},
  onTrigger = () => {},
  onComplete = () => {},
}) {
  const sanitizedFact = {};
  Object.keys(fact).forEach((f) => {
    sanitizedFact[f] = typeof fact[f] === 'string' ? encodeSpecialChars(fact[f]) : fact[f];
  });
  ruleEngine.execute(sanitizedFact, (data) => {
    if (data.result) {
      onSkip(data);
    } else {
      onTrigger(data);
    }
    onComplete();
  });
}
exports.evaluateFact = evaluateFact;
